import React from "react";
import Seo from "@/utils/seo";
import Head from "next/head";
import Banner from "@/components/pages/clients/banner";
import Clients from "@/components/pages/clients/clients";
import { getJsonLd } from "@/utils/get-jsonld";
export default function OurClients() {
  const seo = {
    slug: "/our-clients",
  };

  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getJsonLd({ slug: "our-clients" })),
          }}
        />
      </Head>
      <Banner />
      <Clients />
    </>
  );
}
